module.exports = __webpack_public_path__ + "static/img/178e3bd79b89c8db95cb780bdc00cf36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wk_box.png
// module id = 70Kn
// module chunks = 1